<script setup lang="ts">
import { routerConstants } from '@/constants/routers/common'
import Image from '@/components/atoms/Image/index.vue'

const { PATH } = routerConstants.LOCATION
</script>

<template>
  <div class="questions-index-content">
    <h1 class="questions-index-content-head">
      <a href="/">
        <Image
          :path-pc="'/assets/images/header-logo.png'"
          :path-pc-webp="'/assets/images/header-logo.webp'"
          :width-pc="214"
          :height-pc="48"
          :is-lazy="false"
          :alt="'出張撮影・出張カメラマンマッチングサイト OurPhoto'"
        ></Image>
      </a>
    </h1>
    <h2 class="questions-index-content-title">おすすめフォトグラファー診断</h2>
    <div class="questions-index-content-text">
      いくつかの質問に答えるだけで、相性の良い<br />フォトグラファーを診断します。
    </div>
    <router-link class="questions-index-content-button" :to="PATH.QUESTIONS_ONE"
      >診断スタート<img
        class="questions-index-content-button-icon"
        :src="'/assets/images/iconmonstr-arrow-right-circle-lined-white.svg'"
        alt=""
    /></router-link>
  </div>
</template>

<style lang="scss" scoped>
.questions-index-content {
  &-head {
    img {
      width: 200px;
      @media (max-width: 767px) {
        width: 120px;
      }
    }
  }
  &-title {
    margin-top: 30px;
    font-size: 24px;
    font-weight: 600;
    @media (max-width: 767px) {
      margin-top: 20px;
      font-size: 18px;
    }
  }
  &-text {
    margin-top: 50px;
    font-size: 16px;
    @media (max-width: 767px) {
      margin-top: 30px;
      font-size: 14px;
    }
  }
  &-button {
    position: relative;
    display: block;
    width: 360px;
    height: 72px;
    margin: 40px auto 0;
    font-size: 32px;
    font-weight: 600;
    letter-spacing: 3.2px;
    text-align: center;
    background-color: #333;
    box-shadow: 0px 2px 6px #0000001a;
    border-radius: 36px;
    color: #fff;
    line-height: 72px;
    text-decoration: none;
    @media (max-width: 767px) {
      width: 100%;
      height: 54px;
      margin: 30px auto 0;
      font-size: 24px;
      line-height: 54px;
    }
    &-icon {
      position: absolute;
      top: 50%;
      right: 20px;
      width: 28px;
      height: 28px;
      transform: translateY(-50%);
      @media (max-width: 767px) {
        right: 15px;
        width: 20px;
        height: 20px;
      }
    }
  }
}
</style>
